import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {NotifierService} from 'angular-notifier';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {RestApiService} from '../rest-api.service';
import {MessageService} from '../message.service';
import {Router} from '@angular/router';
import {Formatters} from 'angular-slickgrid';

@Component({
  selector: 'app-ticket-activity-notification-mst',
  templateUrl: './ticket-activity-notification-mst.component.html',
  styleUrls: ['./ticket-activity-notification-mst.component.css']
})
export class TicketActivityNotificationMstComponent implements OnInit , OnDestroy {
    displayed = true;
    subject: string;
    totalData = 0;
    show: boolean;
    selected: number;
    respObject: any;
    add: boolean;
    del: boolean;
    edit: boolean;
    view: boolean;
    displayData: any;
    isError = false;
    errorMessage: string;
    nextOffset: number;
    previousOffset: number;
    pageSize: number;
    paginationType: string;
    ticketName: any;
    activityName: any;
    categoryName: any;
    page_no: number;
    totalPage: number;
    clientId: number;
    private baseFlag: any;
    private userAuth: Subscription;
    private notifier: NotifierService;
    offset: number;
    tickets = [];
    ticket_status = [];
    activity_desc  = [];
    activitySelected: number;
    ticketSelected: number;
    // supportGroupSelected: number;
    ticket_type: string;
    // support_group = [];
    editorValue: string;
    ticketStatus: string;
    supportGroup: string;
    ticketTypeSeqNo: number;
    private modalReference: NgbModalRef;
    categories = [];
    ststusSelected: number;
    category: string;
    categorySelected: number;
    dataLoaded:boolean;
    constructor(private _rest: RestApiService, private messageService: MessageService,
                private route: Router, private modalService: NgbModal, notifier: NotifierService) {
        this.notifier = notifier;
        this.messageService.getCellChangeData().subscribe(item => {
            // console.log(item);
            switch (item.type) {
                case 'change':
                    console.log('changed');
                    if (!this.messageService.edit) {
                        this.notifier.notify('error', 'You do not have edit permission');
                    } else {
                        if (confirm('Are you sure?')) {
                        }
                    }
                    break;
                case 'delete':
                    // console.log('deleted');
                    if (!this.messageService.del) {
                        this.notifier.notify('error', 'You do not have delete permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            // console.log(JSON.stringify(item));
                            this._rest.deleteTicketActivityNoficationMst({id: item.id}).subscribe((res) => {
                                this.respObject = res;
                                // console.log(JSON.stringify(this.respObject));
                                if (this.respObject.success) {
                                    this.messageService.sendAfterDelete(item.id);
                                    this.notifier.notify('success', 'Template Deleted successfully');
                                } else {
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', this.messageService.SERVER_ERROR);
                            });
                        }
                    }
                    break;
            }
        });
        this.messageService.getSelectedItemData().subscribe(selectedTitles => {
            if (selectedTitles.length > 0) {
                this.show = true;
                this.selected = selectedTitles.length;
            } else {
                this.show = false;
            }
        });
        this.messageService.getUserAuth().subscribe(details => {
            // console.log(JSON.stringify(details));
            if (details.length > 0) {
                this.add = details[0].addFlag;
                this.del = details[0].deleteFlag;
                this.view = details[0].viewFlag;
                this.edit = details[0].editFlag;
            } else {
                this.add = false;
                this.del = false;
                this.view = false;
                this.edit = false;
            }
        });
    }

    ngOnInit() {
        this.dataLoaded=false;
        this.nextOffset = 0;
        this.previousOffset = 0;
        this.pageSize = this.messageService.pageSize;
        this.page_no = 0;
        this.totalPage = 0;
        this.paginationType = 'next';
        this.editorValue = '';
        this.ticketStatus = '';
        this.supportGroup = '';
        this.displayData = {
            pageName: 'Maintain Activity Mail Template',
            openModalButton: 'Add Activity Mail Template',
            breadcrumb: 'Activity Mail Template',
            folderName: 'All Activity Mail Template',
            tabName: 'Activity Mail Template'
        };
        // const data = {
        //     clientId: this.clientId, ticket_type_id: this.ticketSelected, ticket_status_id: this.selectedStatus.join(', '),
        //     to_support_group: this.selectedSupportGroup.join(', '), subject: this.subject, template: this.editorValue ,
        //     createdBy: this.messageService.getUserId()
        // };
        const columnDefinitions = [
            {
                id: 'delete',
                field: 'id',
                excludeFromHeaderMenu: true,
                formatter: Formatters.deleteIcon,
                minWidth: 30,
                maxWidth: 30,
            },
            // {id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true},
            {id: 'type', name: 'Ticket Type', field: 'ticketType', sortable: true, filterable: true},
            {id: 'status', name: 'Activity', field: 'activity_desc', sortable: true, filterable: true},
            {id: 'category', name: 'Category', field: 'category', sortable: true, filterable: true},
            {id: 'subject', name: 'Subject', field: 'subject', sortable: true, filterable: true}
        ];
        this.messageService.setColumnDefinitions(columnDefinitions);
        if (this.messageService.clientId) {
            this.clientId = this.messageService.clientId;
            this.baseFlag = this.messageService.baseFlag;
            this.onPageLoad();
        } else {
            this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                this.view = auth[0].viewFlag;
                this.add = auth[0].addFlag;
                this.edit = auth[0].editFlag;
                this.del = auth[0].deleteFlag;
                this.clientId = auth[0].clientId;
                this.baseFlag = auth[0].baseFlag;
                this.onPageLoad();
            });
        }
    }

    onPageLoad() {
        this._rest.getTicketType(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                // console.log( res1);
                this.isError = false;
                this.respObject.details.unshift({id: 0, name: 'Select Ticket Type'});
                this.tickets = this.respObject.details;
                this.ticketSelected = 0;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', JSON.stringify(err));
        });
        this.getActivityDesc();
        this.getTableData();
    }
    getActivityDesc(){
        this._rest.getTicketActivityMst().subscribe((resp) => {
            this.respObject = resp;
            if (this.respObject.success) {
                this.respObject.details.unshift({id: 0, activity_desc: 'Select Activity'});
                this.activity_desc = this.respObject.details;
                // console.log('status==========' + JSON.stringify(this.activity_desc));
                this.activitySelected = 0;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', JSON.stringify(err));
        });
    }

    openModal(content) {
        if (!this.messageService.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.isError = false;
            this.subject = '';
            this.ticket_status = [];
            this.editorValue = '';
            this.modalService.open(content).result.then((result) => {
            }, (reason) => {

            });
        }

    }

    changeRouting(path: string) {
        this.messageService.changeRouting(path);
    }

    // get selectedSupportGroup() {
    //   return this.support_group
    //     .filter(opt => opt.checked)
    //     .map(opt => opt.id);
    // }
    //
    // get selectedSupportGroupName() {
    //   return this.support_group
    //     .filter(opt => opt.checked)
    //     .map(opt => opt.name);
    // }

    get selectedCategory() {
        return this.categories
            .filter(opt => opt.checked)
            .map(opt => opt.id);
    }

    save() {
        // to_support_group: this.selectedSupportGroup.join(', ')
        const data = {
            clientId: this.clientId, ticket_type_id: this.ticketSelected, ticket_activity_id: this.activitySelected,
            category_id: this.categorySelected, subject: this.subject, template: this.editorValue ,
            createdBy: this.messageService.getUserId()
        };
        // console.log('insert data==========', JSON.stringify(data));
        if (!this.messageService.isBlankField(data)) {
            this._rest.insertTicketActivityNoficationMst(data).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    this.totalData = this.totalData + 1;
                    this.messageService.setTotalData(this.totalData);
                    this.isError = false;
                    const id = this.respObject.details;
                    this.messageService.setRow({id: id, ticketType: this.ticketName, activity_desc: this.activityName,
                        category: this.categoryName, subject: this.subject});
                    if (this.totalData <= this.pageSize * this.page_no) {
                      this.offset = id;
                      this.nextOffset = 0;
                    } else {
                      this.nextOffset = this.offset;
                    }
                    // this.nextOffset = 0;
                    // this.page_no = 0;
                    // this.getTableData();
                    this.ticketSelected = 0;
                    this.ststusSelected = 0;
                    this.categorySelected = 0;
                    this.editorValue = '';
                } else {
                    this.isError = true;
                    this.errorMessage = this.respObject.errorMessage;
                }
            }, (err) => {
                this.isError = true;
                this.errorMessage = this.messageService.SERVER_ERROR;
            });
        } else {
            this.isError = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        }
    }

    getTableData() {
        if (!this.messageService.view) {
            this.notifier.notify('error', 'You do not have view permission');
        } else {
            this.getData({'offset': this.nextOffset, 'paginationType': ''});
        }

    }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    getData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this.dataLoaded=false;
        this._rest.getTicketActivityNoficationMst(offset, this.pageSize, paginationType, this.clientId).subscribe((res) => {
            this.respObject = res;
            this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
            this.dataLoaded=true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

    onPageSizeChange(value: any) {
        this.page_no = 0;
        this.nextOffset = 0;
        this.pageSize = value;
        this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }

    onTicketChange(selectedIndex: any) {
        this.ticketName = this.tickets[selectedIndex].name;
        // console.log('saaaaaaaa ' + this.tickets);
        // this.activityName = this.activity_desc[selectedIndex].;
        // this._rest.getStatusByTicketTypeLt(this.ticketTypeSeqNo, this.clientId).subscribe((res) => {
        //     this.respObject = res;
        //     if (this.respObject.success) {
        //         this.respObject.details.unshift({id: 0, status: 'Select Ticket Status'});
        //         this.ticket_status = this.respObject.details;
        //         console.log('status==========' + this.ticket_status);
        //         this.ststusSelected = 0;
        //     } else {
        //         this.notifier.notify('error', this.respObject.errorMessage);
        //     }
        // }, (err) => {
        //     this.notifier.notify('error', JSON.stringify(err));
        // });

        // this._rest.getSupportGroupByTicketTypeLt(this.ticketSelected, this.clientId).subscribe((res) => {
        //   this.respObject = res;
        //   if (this.respObject.success) {
        //     this.support_group = this.respObject.details;
        //   } else {
        //     this.notifier.notify('error', this.respObject.errorMessage);
        //   }
        // }, (err) => {
        //   this.notifier.notify('error', JSON.stringify(err));
        // });

        this._rest.getCategoryByTicketTypeNDynamicLevel(this.clientId, this.ticketSelected).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.respObject.details.unshift({id: 0, name: 'Select Category'});
                this.isError = false;
                this.categories = this.respObject.details;
                this.categorySelected = 0;
            } else {
                this.isError = true;
                this.errorMessage = this.respObject.errorMessage;
            }
        }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
        });
    }
    onCategoryChange(selectedIndex: any){
        // console.log('gaaaaaaaaaaaaaa ' + JSON.stringify(this.categories));
        this.categoryName = this.categories[selectedIndex].name;
    }
    onActivityChange(selectedIndex: any){
        // console.log('maaaaaaaaaaaaaaa ' + JSON.stringify(this.activity_desc));
        this.activityName = this.activity_desc[selectedIndex].activity_desc;
    }
    ngOnDestroy(): void {
        if (this.userAuth) {
            this.userAuth.unsubscribe();
        }
    }
}
